import { requireAnySystemPermission } from '../../../../../backend/features/permissions/shared';
import { defineEntity } from '@juvare/platform-app/App';
import { accountExportTemplateColumns, accountExportTemplateSchema, } from '../../shared/entities/accountExportTemplateTypes';
import { validateExportFields } from '../../utils/validateExportFields';
export const accountExportTemplateEntity = defineEntity({
    version: 1,
    columns: accountExportTemplateColumns,
    onMigrate: (params) => params.oldData,
    onTransformColumns: (_, params) => {
        return {
            accountId: params.data.accountId,
            headerNames: params.data.fields.map(({ headerName }) => headerName),
            name: params.data.name,
            search: params.data.name,
        };
    },
    onAuthPost: (appState, userState, params) => {
        if (!requireAnySystemPermission(userState, 'export-accounts')) {
            throw Error('Not authorized');
        }
        if (params.action === 'delete') {
            return;
        }
        const validation = validateExportFields({ fields: params.data.fields, compareFields: appState.settings.accountExport });
        if (!validation.success) {
            switch (validation.error) {
                case 'does-not-exist':
                    throw Error(`${validation.field} field does not exist.`);
                case 'mismatch':
                    throw Error(`${validation.field} field has different configuration from setting.`);
                default:
                    throw Error(`Unknown error.`);
            }
        }
    },
    audit: {
        columnForAuditIdReplacement: 'name',
    },
}, accountExportTemplateSchema);
